import isEmpty from 'lodash.isempty';
import { Tab, Tabs, TabPanel } from '@geberit/gdds';

// types
import { EventsSorted } from './investors-calendar.types';

// components
import EventsContent from './events-content';

// utils
import { useTracking } from '../../../utils/hooks/useTracking';
import { tabClick } from '../../ContentElements/tabs/tracking-actions';
import { getSortedEvents } from './utils';

interface InvestorTabsProps {
  futureEventsTitle: string;
  pastEventsTitle: string;
  locale: Locale;
  currentYear: number;
  setCurrentYear: (year: number) => void;
  events: EventsSorted;
  language: string;
}

function InvestorTabs({
  futureEventsTitle,
  pastEventsTitle,
  locale,
  currentYear,
  setCurrentYear,
  events,
  language,
}: Readonly<InvestorTabsProps>) {
  // pre-open current year tab
  const initialSelected = events.findIndex((item) => item.year === currentYear);

  // tracking on tab change
  const track = useTracking();
  const onChange = ({ title }) => {
    setCurrentYear(parseInt(title));
    track.trackEvent(tabClick(title));
  };

  return (
    <Tabs
      alignment="horizontal"
      tabPanelPosition="bottom"
      initialSelected={initialSelected}
      onTabChange={onChange}
    >
      {!isEmpty(events) && events.map((item) => <Tab title={String(item.year)} key={item.year} />)}
      <TabPanel>
        {!isEmpty(events) &&
          events.map((item) => {
            const [upcomingEvents, pastEvents] = getSortedEvents(item);

            return (
              <EventsContent
                pastEvents={pastEvents}
                upcomingEvents={upcomingEvents}
                futureEventsTitle={futureEventsTitle}
                pastEventsTitle={pastEventsTitle}
                locale={locale}
                key={item.year}
                language={language}
              />
            );
          })}
      </TabPanel>
    </Tabs>
  );
}

export default InvestorTabs;
